export class MemberContactRoleEntity {
  id: number;
  name_En: string;
  name_Fr: string;

  constructor(entity?: MemberContactRoleEntity) {
    if (entity) {
      Object.assign(this, { ...entity });
    } else {
      this.id = 0;
      this.name_En = '';
      this.name_Fr = '';
    }
  }
}
